import { render, staticRenderFns } from "./AssetsManagerModal.vue?vue&type=template&id=247cb5d0"
import script from "./AssetsManagerModal.vue?vue&type=script&lang=js"
export * from "./AssetsManagerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports